<template>
    <transition name="modal">
        <div class="modal-mask">
            <vue-particles
                v-if="showConfetti"
                id="tsparticles"
                :options="confettiOptions"
                style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 99999; pointer-events: none;"
            />
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container modalContainer" @click.stop="">
                    <div ref="modalBody" class="modal-body contentmodal">
                        <div v-show="cameraAllowed" class="content" style="box-sizing: border-box">
                       
                            <video ref="video" id="player" style="box-sizing: border-box;" muted autoplay playsinline
                                :style="[codeFound.status ? { height: 0 } : {}]"></video>
                                <canvas ref="canva" id="snapshot"
                                style="opacity:0; height:0;width:0"></canvas>
                            <div class="textcontainer">
                                <div :style="[
                                    !codeFound.confirmed ? 'justify-content: flex-end' : '',
                                ]" class="actionContainer">
                                    <div v-if="!codeFound.status" class="help">
                                        <p>
                                            {{ this.$root.language.wsm_pointvision_scanyourcode }}
                                        </p>
                                    </div>
                                    <div class="codeAdded" v-if="codeFound.confirmed">
                                        <h1>{{this.$root.language.wsm_successPointshopSignupHeadline}}</h1>
                                        <p class="congrats">{{ codeFound.message }}</p><br></br>
                                        <p class="thecode">{{ codeFound.code }}</p>
                                    </div>
                                    <div class="codeAdded codeError" v-if="codeFound.confirmed == false && codeFound.status">
                                        <h1>{{this.$root.language.wsm_sorryThereWasAnError}}</h1>
                                        <p>{{ codeFound.message }}</p>
                                        <p class="thecode">{{ codeFound.code }}</p>
                                        <br>
                                        <button v-if="!manualCodeEntry" class="scannew" @click="scannew">{{ this.$root.language.wsm_pointvision_tryagain }}</button>
                                        <button v-if="!manualCodeEntry" class="scannew"
                                            @click="manualCodeEntry = true">{{ this.$root.language.wsm_pointvision_enterCodeManually }}</button>
                                        <br>
                                        <div class="codeInput" v-if="manualCodeEntry">
                                            <p>{{ this.$root.language.wsm_pointvision_enterCodeManually }}</p>
                                            <input v-model="manualCode" type="text" />
                                            <button class="sendManualCode" @click="codeConfirm(manualCode)">OK</button>
                                        </div>

                                    </div>
                                    <div class="btnactions">
                                        <button v-if="codeFound.status && codeFound.confirmed" @click="scannew" class="scannew">
                                            {{this.$root.language.wsm_pointvision_scannewcode}}
                                        </button>
                                        <button :style="[
                                            !codeFound.status ? 'justify-content: flex-end' : '',
                                        ]" @click="closescan" class="closeScan">
                                            {{ this.$root.language.wsm_closeAccountButton_SecondPopUp }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content" v-if="!cameraAllowed">
                            <div class="givepermission">
                                <p v-if="!denied">
                                   {{this.$root.language.wsm_pointvision_cameraccess}}
                                </p>
                                <p v-if="denied">{{ this.$root.language.wsm_pointvision_nocameraaccess }}</p>
                                <button v-if="denied" :style="[
                                    !codeFound.status ? 'justify-content: flex-end' : '',
                                ]" @click="closescan" class="closeScan">
                                    {{ this.$root.language.wsm_closeAccountButton_SecondPopUp }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios';

export default {
    name: "scanner",
    data() {
        return {
            cameraAllowed: false,
            denied: false,
            stop: false,
            manualCode: '',
            scanTimeout: null,
            manualCodeEntry: false,
            showConfetti: false,
            codeFound: {
                status: false,
                message: "",
                code: null,
                confirmed: null,
            },
            // Prefix is a country code + campaign digit(s), e.g. FI1-2E5-H78. OCR often swaps I/1 and O/0,
            // so those are accepted in the prefix and corrected in normalizeActionCode
            actionCodePattern: /\b([A-Z01]{2})([0-9IO]{1,2})-([A-Z0-9]{3}-[A-Z0-9]{3})\b/,
            confettiOptions: {
                fullScreen: {
                    enable: false
                },
                fpsLimit: 30,
                particles: {
                    number: {
                        value: 0
                    },
                    color: {
                        value: ["#7caf63", "#418a90", "#FFD700", "#FF6B6B", "#4ECDC4", "#95E1D3"]
                    },
                    shape: {
                        type: ["circle", "square"]
                    },
                    opacity: {
                        value: 1
                    },
                    size: {
                        value: { min: 3, max: 8 }
                    },
                    move: {
                        enable: true,
                        speed: { min: 10, max: 20 },
                        direction: "bottom",
                        random: true,
                        straight: false,
                        outModes: {
                            default: "destroy"
                        },
                        gravity: {
                            enable: true,
                            acceleration: 9.8
                        }
                    },
                    rotate: {
                        value: { min: 0, max: 360 },
                        direction: "random",
                        animation: {
                            enable: true,
                            speed: 30
                        }
                    }
                },
                detectRetina: true,
                emitters: [
                    {
                        position: {
                            x: 25,
                            y: 0
                        },
                        rate: {
                            quantity: 3,
                            delay: 0.15
                        },
                        size: {
                            width: 10,
                            height: 0
                        }
                    },
                    {
                        position: {
                            x: 50,
                            y: 0
                        },
                        rate: {
                            quantity: 5,
                            delay: 0.15
                        },
                        size: {
                            width: 10,
                            height: 0
                        }
                    },
                    {
                        position: {
                            x: 75,
                            y: 0
                        },
                        rate: {
                            quantity: 3,
                            delay: 0.15
                        },
                        size: {
                            width: 10,
                            height: 0
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.initScanner();
    },
    methods: {
        async rerequest() {
            const status = await navigator.permissions.query({name: "camera"});
            status.addEventListener("change", (evt) => {
            // request again
            navigator.mediaDevices.getUserMedia({ video: true })
                .then(handleStream)
                .catch(handleDeny);
            }, { once: true });
     
        },
        async initScanner() {

            this.cameraAllowed = false;
            this.denied = false;
            const player = this.$refs.video;

            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: { facingMode: "environment" },
                });

                this.cameraAllowed = true;
                player.srcObject = stream;

                this.startScanning();
            } catch (error) {
                console.error("Camera access denied:", error);
                this.denied = true;
            }
        },
        startScanning() {
            const scanInterval = 1000; // ms, adjust as needed
            const player = this.$refs.video;
            const canvas = this.$refs.canva

            const captureAndProcess = () => {
                if (this.stop || this.codeFound.status) return;

                canvas.width = player.videoWidth;
                canvas.height = player.videoHeight;
                canvas.getContext('2d').drawImage(player, 0, 0, canvas.width, canvas.height);
           
                this.processImage(canvas.toDataURL('image/jpeg'));
                this.scanTimeout = setTimeout(captureAndProcess, scanInterval);
                
            };

            captureAndProcess();
        },
        async processImage(imageData) {
            try {
                const base64Image = imageData.split(',')[1];
                const response = await this.callGoogleVisionAPI(base64Image);

                const text = this.extractTextFromResponse(response);
                const match = text.toUpperCase().match(this.actionCodePattern);

                if (match && !this.codeFound.status) {
                    this.codeFound.status = true;
                    this.codeFound.code = this.normalizeActionCode(match);
                    this.codeConfirm(this.codeFound.code);
                }
            } catch (error) {
                console.error("Image processing error:", error);
            }
        },
        async callGoogleVisionAPI(base64Image) {
            if (base64Image) {
                const apiKey = 'AIzaSyBKefIWPOF9jF2iW4WfdBmMB8c-4pa9Euk'; // Replace with your actual API key
                const apiEndpoint = `https://vision.googleapis.com/v1/images:annotate?key=${apiKey}`;

                const requestBody = {
                    requests: [{
                        image: {
                            content: base64Image
                        },
                        features: [{
                            type: 'TEXT_DETECTION'
                        }]
                    }]
                };

                const response = await axios.post(apiEndpoint, requestBody);
                return response.data;
            }

        },
        normalizeActionCode([, country, digits, rest]) {
            // Country code is always letters and the campaign part always digits
            country = country.replace(/1/g, 'I').replace(/0/g, 'O');
            digits = digits.replace(/I/g, '1').replace(/O/g, '0');
            return `${country}${digits}-${rest}`;
        },
        extractTextFromResponse(response) {
            if (response?.responses && response?.responses[0] && response?.responses[0].fullTextAnnotation) {
                return response.responses[0].fullTextAnnotation.text;
            }
            return '';
        },
        async closescan() {
            if (this.$refs.video.srcObject) {
                this.$refs.video.srcObject.getTracks()[0].stop();
                this.$refs.video.srcObject = null;
            }
            this.resetState();
            this.$emit("closemodal");
        },
        resetState() {
            this.codeFound = {
                status: false,
                code: null,
                message: "",
                confirmed: null,
            };
            clearTimeout(this.scanTimeout)
            this.scanTimeout = null;
            this.manualCode = '';
            this.manualCodeEntry = false;
            this.stop = false;
            this.showConfetti = false;
        },
        scannew() {
            this.resetState();
            this.startScanning();
        },
        codeConfirm(code) {
            this.stop = true;
            this.codeFound.code = code;
            this.manualCodeEntry = false;
            this.showConfetti = false;
            axios.get(
                    this.$root.basedir +
                    '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"PointShopCode", pointShopCode:' + encodeURI(code) + ', "isPointShop":"Y"}',
                    {
                        headers: {
                            "Content-type": "application/json",
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    }
                )
                .then((response) => {
                    this.res = response.data
                    switch (response.data.status) {
                        case 200:
                            this.codeFound.confirmed = true;
                            this.codeFound.message = response.data.message;
                            this.showConfetti = true;
                            this.$store.dispatch('updatePointShopWidget');
                            this.$emit('code-success');
                                gtag('event', 'pointshop_camera', {
                                    'event_category' : 'pointshop',
                                    'event_label' : 'success',
                                    'code_input': code,
                                });
                            break;
                        default:
                            this.codeFound.confirmed = false;
                            this.showConfetti = false;
                            this.codeFound.message = response.data.errorMessage;
                                gtag('event', 'pointshop_camera', {
                                    'event_category' : 'pointshop',
                                    'event_label' : 'error',
                                    'code_input': code,
                                    'error_message': response.data.errorMessage
                                });
                    }
                    setTimeout(() => {
                        this.stop = false
                    }, 1000)

                });

            setTimeout(() => {
                this.stop = false;
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    //height: 100svh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    margin: 0 auto;
    transition: opacity 0.3s ease;
    align-items: center;
    justify-content: center;
}

.modal-wrapper {
    width: 100%;
    height: 80%;
    height: 80svh;
}

.modal-container {
    height: 100%;
    margin: 0px auto;
    position: relative;
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #004570;
    font-size: 1.5em;

    i {
        color: #004570;
        font-size: 1em;
    }
}

.modal-header {
    background: #f2f2f2;
    padding: 17px;
    border-bottom: 1px solid #d4d4d4;

    p {
        margin-left: 31px !important;
        width: 87%;
        color: #5e5e5e;
    }
}

.modal-footer {
    display: block;
    position: relative;
    width: 93%;
    height: 30px;
    padding: 23px;
    padding-top: 0;

    .backBtn {
        float: left;

        i {
            color: white;
            vertical-align: text-bottom;
        }
    }
}

.modal-body {
    margin: 0;
    padding: 20px 30px;
    padding-top: 0;

    h3 {
        color: #004570;
        font-size: 2em;
        text-align: center;

        i {
            font-size: 1em;
            color: inherit;
        }
    }

    .modal-default-button {
        float: right;
        background: #004570;
        color: white;
        padding: 9px;
        border-radius: 4px;
        cursor: pointer;
        border: none;

        &:hover {
            background: #206d9c;
        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container,
    .modal-leave-active {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active,
    .slide-fade-leave-active,
    .slide-fade2-enter-active,
    .slide-fade2-leave-active,
    .btn-fade-enter-active,
    .btn-fade-leave-active {
        transition: all 0.3s ease;
    }

    .header-fade-enter-active,
    .header-fade-leave-active {
        transition: all 1s ease;
    }

    .slide-fade-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateX(-10px);
        opacity: 0;
    }

    .slide-fade-enter

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateX(10px);
        opacity: 0;
    }

    .slide-fade2-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateX(10px);
        opacity: 0;
    }

    .slide-fade2-enter

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateX(-10px);
        opacity: 0;
    }

    .btn-fade-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateY(10px);
        opacity: 0;
    }

    .btn-fade-enter

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateY(10px);
        opacity: 0;
    }

    .header-fade-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateY(10px);
        opacity: 0;
    }

    .header-fade-enter

    /* .slide-fade-leave-active below version 2.1.8 */
        {
        transform: translateY(10px);
        opacity: 0;
    }

    .modal-footer {
        display: block;
        width: 93%;
        position: relative;
        height: 30px;
        padding: 14px;
        padding-top: 0;
    }
}

/* new styles */
.modalContainer {
    display: flex;
    justify-content: center;

    .contentmodal {
        max-width: 420px;
        width: 90%;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        button {
            border: 2px solid #418a90;
            border-radius: 8px;
            padding-left: 1rem;
            width: 90%;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
            padding-right: 1rem;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            font-size: 1rem;
            font-weight: bold;
        }

        .content {
            display: flex;
            flex-direction: column;
        }

        .givepermission {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 2rem;

            button {
                background: #418a90;
                color: white;
            }

            p {
                color: black;
            }
        }

        .help {
            background: rgba(65, 137, 144, 0.9);
            padding: 1rem;
            color: #c4f5f5;
            border-radius: 8px;
            line-height: 1.2rem;
            font-size: 0.8rem;

            p {
                color: inherit;
                margin-bottom: 0;
            }
        }

        .textcontainer {
            padding: 1rem;
            display: flex;
            flex-direction: column;
            height: -webkit-fill-available;

            .actionContainer {
                position: relative;
                height: 100%;
                display: flex;
                flex-direction: column;
                width: 100%;
                justify-content: center;
            }

            .codeAdded {
                justify-content: center;
                align-items: center;
                display: flex;
                flex-direction: column;
                height: 100%;

                h1 {
                    color: #7caf63;
                    font-weight: bold;
                }

                p {
                    text-align: center;
                    color: black;
                    width: 80%;
                    font-size: 1rem;
                    font-weight: 500;
                }

                .thecode {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #418a90;
                    line-height: 1.6rem;
                    margin: 0;
                }

                
                .congrats {
                    font-size: 4rem;
                    font-weight: bold;
                    color: #68cf2c;
                    line-height: 4rem;
                    margin: 0;
                }

                .codeInput {
                    width: 86%;

                    input {
                        font-size: 2rem;
                        height: 3rem;
                        border-radius: 8px;
                        background: #fafafa;
                        font-weight: bold;
                        color: #418a90;
                    }

                    p {
                        margin: 0;
                        text-align: left;
                    }

                    .sendManualCode {
                        width: 100%;
                        background: #418a90;
                        color: white;
                    }
                }
            }

            .codeError {
                h1 {
                    color: rgb(193, 88, 88);
                }
            }

            .btnactions {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .scannew {
                background: white;
                color: #418a90;

                &:active {
                    background: #418a90;
                    color: white;
                }
            }

            .closeScan {
                background: #418a90;
                color: white;
                min-height:40px;
            }

        }

        .status {
            color: rgb(21, 21, 53);
            font-weight: bold;
        }

        #player {
            display: block;
            width: 100%;
            max-width: 100%;
            height: auto;
            
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }

        .content {
            width: 100%;
            height: 90vh; //Fallback value
            height: 90svh;
            transition: height .2 ease;
            background: white;
            border-radius: 25px;
        }
    }
    .actionContainer .help{
        position: absolute;
        top: -150px;
        z-index: 100;
    }

}
</style>
